/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SelectorTools from 'app/utility/SelectorTools.js';
import * as _ from 'underscore';

class ComboButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedAction: '',
            actionsVisible: false
        };

        this.menuRef = React.createRef();
        this.showOptionsRef = React.createRef();

        this.showActions = this.showActions.bind(this);
        this.doAction = this.doAction.bind(this);
        this.selectAction = this.selectAction.bind(this);
        this.lookupIndex = this.lookupIndex.bind(this);
        this.interactionCheck = this.interactionCheck.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {};

        if (props.selectedAction !== '' && state.selectedAction === '') {
            nextState.selectedAction = props.selectedAction;
        } else if (props.selectedAction !== state.selectedAction) {
            nextState.selectedAction = props.selectedAction;
        }

        return (Object.keys(nextState).length) ? nextState : null;
    }

    componentDidMount() {
        document.addEventListener('mouseup', this.interactionCheck);
        document.addEventListener('touchend', this.interactionCheck);
    }

    componentWillUnmount() {
        document.removeEventListener('mouseup', this.interactionCheck);
        document.removeEventListener('touchend', this.interactionCheck);
    }

    interactionCheck(e) {

        if ((this.menuRef.current && this.menuRef.current.contains(e.target)) ||
            (this.showOptionsRef.current && this.showOptionsRef.current.contains(e.target))) {
            return;
        } else {
            if (this.state.actionsVisible) {
                e.preventDefault();
                e.stopPropagation();
                this.setState({
                    actionsVisible: false
                });
            }
        }

    }

    showActions(e) {
        let visible = this.state.actionsVisible ? false : true;

        this.setState({
            actionsVisible: visible
        });

    }

    selectAction(e) {
        let selectedAction = this.state.selectedAction,
            selectedIndex = 0;

        if (e) {
            selectedAction = e.currentTarget.dataset.action;
            selectedIndex = this.lookupIndex(selectedAction);

            if (this.props.selectActionCallback !== null) {
                this.props.selectActionCallback.apply(this, [e, this.props.actions[selectedIndex], selectedIndex]);
            }

            this.setState({
                selectedAction,
                actionsVisible: false
            });

            if (this.props.actions[selectedIndex].immediate) {
                this.props.actions[selectedIndex].callback.call(this);
            }

        }

    }

    doAction(e) {

        let actionIndex = this.lookupIndex(this.state.selectedAction);

        this.props.actions[actionIndex].callback.call(this);

    }

    lookupIndex(action) {
        let lookup = (action) ? action : this.state.selectedAction;

        return _.findIndex(this.props.actions, function(value) {
            return value.action === lookup
        }.bind(this));

    }

    render () {
        let selectors = new SelectorTools({
                buttonMain: 'combo-button',
            }),
            actions = null,
            icon = null,
            actionIndex = 0;

        actionIndex = _.findIndex(this.props.actions, function(value) {
            return value.action === this.state.selectedAction;
        }.bind(this));

        if (actionIndex < 0) {
            actionIndex = 0;
        }

        if (this.state.actionsVisible) {
            actions = (
                <ul className="combo-actions top" ref={this.menuRef}>
                    {this.props.actions.map((action, index) => {
                        let icon = null;
                        if (action.icon) {
                            icon = (
                                <div className="combo-icon">
                                    {action.icon}
                                </div>
                            );
                        }

                        if (actionIndex === index) {
                            return null;
                        }

                        return (
                            <li key={index} data-index={index} data-action={action.action} onClick={this.selectAction} role="button" aria-label={action.label}>
                                {icon}
                                {action.label}
                            </li>
                        );
                    })}
                </ul>
            );
        }

        if (this.props.actions[actionIndex].icon) {
            icon = (
                <div className="combo-icon">
                    {this.props.actions[actionIndex].icon}
                </div>
            );
        }

        return (
            <div className={selectors.buttonMain}>
                <div className="combo-button-label" onClick={this.doAction} role="button" aria-label={this.props.actions[actionIndex].label}>
                    <div className="inner-padding">
                        {icon}
                        {this.props.actions[actionIndex].label}
                    </div>
                </div>
                <div className="combo-button-actions" ref={this.showOptionsRef} onClick={this.showActions} role="button" aria-label="show other actions">
                    <div className="inner-padding">
                        <i className="icon ion-chevron-down" />
                    </div>
                </div>
                {actions}
            </div>
        );
    }
};

ComboButton.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.element,
            label: PropTypes.string,
            callback: PropTypes.func,
        })
    ),
    buttonClass: PropTypes.string,
    selectActionCallback: PropTypes.func,
    selectedAction: PropTypes.string
};

ComboButton.defaultProps = {
    actions: [],
    buttonClass: '',
    selectActionCallback: null,
    selectedAction: ''
};

export default ComboButton;
